/* eslint-disable max-len */

import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Link } from 'react-router-dom'
import { useOnClickOutside } from '../../../../../../CommonMethods/OutsideClick';
import FilterObserverBtn from '../Filter';
import ActivityChangeVitalPatient from '../Export';


const PatientVitalHistoryTopBar = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    AddButton,
    menuBar,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    suggestions,
    setSuggestions,
    optimizedFn,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    toAddScreen,
    isExportList,
    isExport,
    setConfirmationState, data, exportVitalHistory, isIdexport, isFilterOrganization }) => {

    const [searchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const outSideClick = useRef();
    const filtervals = useSelector(state => state.systemConfigData.filterState)
    const [dateError, setdateError] = useState(false)
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })


    const handleOpenFilter = () => {
        setdateError(false)
        if (isFilterOrganization) {
            if ((searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
                setFilterValues(filtervals)

            }
            else if (searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
                setFilterValues({
                    "filter_start_date": '',
                    "filter_end_date": '',
                })
            }

        } else {
            if ((searchParams.get("field") !== null || searchParams.get("action") !== null || searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
                setFilterValues(filtervals)
            }
            else if (searchParams.get("field") === null && searchParams.get("user_name") === null && searchParams.get("action") === null && searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
                setFilterValues({
                    "filter_start_date": '',
                    "filter_end_date": '',
                    // 'user_name': '',
                    // 'column_field': '',
                    // 'action_performed': ''

                })
            }

        }

        setIsFilterOpen(!isFilterOpen)
    }

   



    return (
        <div className="flex justify-between items-center mb-[14px]">
            {title !== undefined ?
                <h1 className="text-xl font-normal text-[#000000] min-w-fit">{title}</h1>
                :
                pathPlaceholder &&
                <Link to={path} state={username && path !== '/manage-observer/' ? [username] : null} className='flex items-center min-w-max'>
                    <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                    <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                </Link>
            }
            <h1 className={`text-xl font-normal text-[#000000] text-center w-full ${data?.data?.length === 0 || data?.data?.length===undefined ? "mr-[157px]" : 'mr-0'}`}>Monitoring Conditons Changes</h1>
            <div className="flex items-center justify-end relative">
               
                {(ApplyFilter !== undefined && ApplyFilter) &&
                    <FilterObserverBtn
                        dateError={dateError}
                        setdateError={setdateError}
                        isFilterOpen={isFilterOpen}
                        setIsFilterOpen={setIsFilterOpen}
                        handleApplyFilter={handleApplyFilter}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        initialState={initialState}
                        handleOpenFilter={handleOpenFilter} />
                }
                {(SearchInput || isExport) && data !== undefined && data?.data?.length > 0 && <div>  <ActivityChangeVitalPatient
                    exportVitalHistory={exportVitalHistory}
                    isExportList={isExportList}
                    exportCols={exportCols}
                    setIsFilterOpen={setIsFilterOpen}
                    isColumnSelect={isColumnSelect}
                    setIsColumnSelect={setIsColumnSelect}
                    isIdexport={isIdexport} 
                    username={username}                     
                />
                </div>}
            </div>
        </div>
    );
}

export default PatientVitalHistoryTopBar;
